export default "__VITE_ASSET__562c6412__"